export const withCommas = (num: any) =>
  `${num}`.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
